import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faCheckSquare as fasCheckSquare,
    faCheck as fasCheck,
    faEdit as fasEdit,
    faCaretDown as fasCaretDown,
    faChevronDown as fasChevronDown,
    faChevronLeft as fasChevronLeft,
    faChevronRight as fasChevronRight,
    faBars as fasBars,
    faSortUp as fasSortUp,
    faTimesCircle as fasTimesCircle,
    faTimes as fasTimes,
    faCheckCircle as fasCheckCircle,
    faInfoCircle as fasInfoCircle,
    faExclamation as fasExclamation,
    faExclamationTriangle as fasExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

import {
    faSquare as farSquare,
    faDotCircle as farDotCircle,
    faCircle as farCircle,
    faSearch as farSearch,
    faArrowUp as farArrowUp,
} from '@fortawesome/pro-regular-svg-icons';

// https://fontawesome.com/icons
library.add(
    farSquare,
    fasCheck,
    farDotCircle,
    farCircle,
    fasEdit,
    fasCaretDown,
    fasBars,
    fasChevronDown,
    fasChevronLeft,
    fasChevronRight,
    fasSortUp,
    fasTimesCircle,
    fasTimes,
    fasCheckCircle,
    fasInfoCircle,
    fasExclamation,
    fasExclamationTriangle,
    farSearch,
    farArrowUp,
    fasCheckSquare
);

// This is a partial list of Vuetify FontAwesome icons. Keep this as minimal as possible for tree shaking.
// Note: We can't simply use Vuetify `faSvg` icon pack preset because this will import all of FontAwesome and we'll lose tree shaking.
// The complete list can be seen at https://github.com/vuetifyjs/vuetify/blob/17dacdd497e3e9ef1fb1f79a17ccfcd273ff6f58/packages/vuetify/src/components/Vuetify/mixins/icons.ts#L95-L123
const icons = {
    complete: 'fas fa-check',
    cancel: 'fas fa-times-circle',
    close: 'fas fa-times',
    delete: 'fas fa-times-circle',
    clear: 'fas fa-times-circle',
    success: 'fas fa-check-circle',
    info: 'fas fa-info-circle',
    warning: 'fas fa-exclamation',
    error: 'fas fa-exclamation-triangle',
    prev: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    checkboxOn: 'fas fa-check-square',
    checkboxOff: 'far fa-square',
    sort: 'far fa-arrow-up',
    expand: 'fas fa-chevron-down',
    menu: 'fas fa-bars',
    subgroup: 'fas fa-caret-down',
    dropdown: 'fas fa-caret-down',
    radioOn: 'far fa-dot-circle',
    radioOff: 'far fa-circle',
    edit: 'fas fa-edit',
    search: 'far fa-search',
};

const props = {
    dropdown: {
        transform: 'shrink-6 up-1',
    },
    sort: {
        transform: 'shrink-7 right-4',
    },
    prev: {
        transform: 'shrink-6 left-1',
    },
    checkboxOn: {
        transform: 'shrink-5 right-1',
    },
    checkboxOff: {
        transform: 'shrink-5 right-1',
    },
};

for (const icon in icons) {
    icons[icon] = {
        component: FontAwesomeIcon,
        props: Object.assign({
            icon: icons[icon].split(' fa-'),
            transform: 'shrink-6',
        }, props[icon] || {}),
    };
}

export default icons;
